module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/id/5-3f992e02173a76a885e22adc0eb105d5.jpg";